/**
 * @desc 创建
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: defs.tms.LogisticsQuotationCreateDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/tms/logisticsQuotation/create`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
